import React from "react";
import { AppBar, Toolbar, Link, Typography, Button, Box } from '@mui/material';
import useStyles from '../theme/formCssStyles';
import DrawerComponent from "../Components/Drawer";
import { makeStyles } from '@mui/styles';
import { useAuth } from '../context/authContext';
import { useHistory, useRouteMatch } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { roleLabel } from '../Components/roles';

const drawerWidth = 232;

const useStyles2 = makeStyles((theme) => ({
  appContent: {
    flex: "1 1 100%",
    maxWidth: "100%",
    paddingTop: 72,
    marginLeft: drawerWidth + 3,
    marginTop: 4,
    marginRight: 16,
    marginBottom: 16,
    paddingLeft: 8,
    paddingRight: 8,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginTop: 12,
      marginRight: 8,
      marginBottom: 8,
      paddingTop: 72,
      paddingLeft: 0,
      paddingRight: 0
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: theme.breakpoints.values.lg
    }
  }
}));

function MainLayout(props) {
  const classes1 = useStyles();
  const classes = useStyles2();
  const { children } = props;

  const { logout, user } = useAuth();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const clubMatch = useRouteMatch('/club/:issuerId');
  const userRole = Number(user?.role ?? user?.userType ?? user?.type ?? user?.role_id ?? user?.roleId);
  // When inside a club the logo returns to that club's home; otherwise to the
  // generic landing page. The club name is URL-driven for the superadmin (shown
  // only while on a /club/:issuerId page) so it never lingers on the chooser.
  const logoHref = (clubMatch && clubMatch.params) ? `/club/${clubMatch.params.issuerId}/home` : '/';
  const showClubName = Boolean(user?.clubName) && (userRole !== 100 || Boolean(clubMatch));

  const handleLogout = () => {
    logout();
    history.push('/login');
  };

  return (
    <div>
      <AppBar className={classes1.appBar}>
        <Toolbar>
          <Box style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
            <Link href={logoHref} color="inherit" variant={isMobile ? 'h6' : 'h5'} style={{ marginLeft: isMobile ? '44px' : '3ch' }}>OmniQpon</Link>
          </Box>
          <Box style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 6 : 12, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {showClubName && (
              <Typography variant={isMobile ? 'body2' : 'body1'} color="inherit" style={{ fontWeight: 600 }}>
                Club: {user.clubName}
              </Typography>
            )}
            {user && !isMobile && (
              <Typography variant="body1" color="inherit">
                {user.displayName || user.username}
              </Typography>
            )}
            {user && !isMobile && (
              <Typography variant="body2" color="inherit" style={{ opacity: 0.9 }}>
                ({roleLabel(user.role)})
              </Typography>
            )}
            <Button color="inherit" onClick={handleLogout} size="small">
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <DrawerComponent drawerWidth={drawerWidth} />
      <main className={classes.appContent}>
        {children}
      </main>
    </div>
  );
}

export default MainLayout;